import { useQuery } from '@tanstack/react-query';
import { queries } from 'src/config/queries';
import { useHostContext } from 'src/core/hooks/useHostContext';
import { NumberHelper } from 'src/shared/helpers/number';
function formatOfferPrice(offer) {
    try {
        return offer?.price?.value && offer.price.currency
            ? NumberHelper.formatCurrency(offer.price.value, offer.price.currency)
            : '';
    }
    catch {
        return '';
    }
}
export function useFreeSignupInfo(isFreeModule) {
    const { subdomain, product } = useHostContext();
    const freeSignupQuery = useQuery({
        ...queries.product.freeSignupStatus(subdomain),
        enabled: isFreeModule
    });
    const offerQuery = useQuery({
        ...queries.product.offer(product.id),
        enabled: freeSignupQuery.data === false && isFreeModule
    });
    return {
        offerId: offerQuery.data?.offer ?? '',
        isFreeSignupAllowed: freeSignupQuery.data,
        isLoadingOffer: offerQuery.isFetching,
        isLoadingFreeSignup: freeSignupQuery.isFetching,
        isLoading: freeSignupQuery.isFetching || offerQuery.isFetching,
        offerPrice: formatOfferPrice(offerQuery.data)
    };
}
